// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"398":"0b0150db","624":"9bfeefeb","711":"f779a2f4","772":"2c3a27f0","942":"7bbf6103"}[chunkId] + ".chunk.js";
};